import shared from "../data/js/shared";
import Img from "../components/img";
import { IS_MOBILE } from "../data/js/server-constants";

const GUARANTEE_URL = `/sellwild-buyer-guarantee`

const {
	buyerProtectionHeading,
	buyerProtectionExplain,
} = shared.post;

interface BuyerProtectionProps {
	heading?: string;
	text?: string;
	/**
	 * Render as plain text with nowhere to go. Set where the guarantee page does
	 * not apply — adoption fees are the shelter's terms, not ours.
	 */
	noLink?: boolean;
}

/**
 * The trust card at the foot of the buy box.
 *
 * The whole card is the link. It used to end with a "Learn More" anchor on its
 * own line, which cost a line of height in a panel that is a fixed 520px and
 * gave a two-line target inside an area that was already entirely about one
 * destination. The card carries `aria-label` so the link still announces what
 * it is without the visible text.
 *
 * A `detailed` variant once listed the four covered cases in a hover tooltip on
 * the checkout. It was removed: the card is the last thing in the order panel,
 * so the tooltip could only open upwards over the Total, and opening it
 * downwards was clipped by `.col2 > .right`. The guarantee page carries the
 * same four cases, and the whole card already goes there.
 */
const BuyerProtection = ({ heading, text, noLink }: BuyerProtectionProps) => {
	const o = IS_MOBILE ? {} : { target: "_blank", rel: "noopener noreferrer" };
	const title = heading ?? buyerProtectionHeading;

	const body = (
		<>
			<div className="image">
				<Img src="/images/svg/buyer-protection-badge.svg" />
			</div>
			<div className="text">
				<h3>{title}</h3>
				<p>{text ?? buyerProtectionExplain}</p>
			</div>
		</>
	);

	if (noLink) {
		return <div className="buyer-protection same-color-border">{body}</div>;
	}

	return (
		<a
			className="buyer-protection same-color-border is-link"
			href={GUARANTEE_URL}
			aria-label={title}
			data-testid="buyer-protection-link"
			{...o}
		>
			{body}
		</a>
	);
};

export default BuyerProtection;
